import type { SelectHTMLAttributes } from 'react';
import { forwardRef } from 'react';

type Option = {
  label: string;
  value: string;
};

type Props = {
  options: Option[];
  placeholder?: string;
  height?: number;
} & SelectHTMLAttributes<HTMLSelectElement>;

const SelectBox = forwardRef<HTMLSelectElement, Props>(
  ({ options, placeholder = undefined, height = 42, ...props }, ref) => {
    return (
      <select
        ref={ref}
        {...props}
        className="w-full appearance-none rounded border border-solid border-border bg-[url('/marker/icon-arrow-down-black.svg')] bg-[length:12px_auto] bg-[right_12px_center] bg-no-repeat pl-4 focus:border-2 focus:border-primary! focus-visible:outline-hidden"
        style={{ height }}
      >
        <option value="" hidden={!props.value || placeholder === ''}>
          {placeholder ?? ''}
        </option>
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    );
  }
);

SelectBox.displayName = 'SelectBox';

export default SelectBox;
